import { defineAsyncComponent } from "vue";
export default [
  {
    name: "AssignmentAttemptWaitingRoom",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerWaitingRoom"),
    ),
    path: "waiting-room",
    props: true,
  },
  {
    name: "AssignmentAttemptPaused",
    component: defineAsyncComponent(() => import("@modules/attempt/components/AssignmentPaused")),
    path: "paused",
    props: true,
  },
  {
    name: "AssignmentAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AssignmentAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AssignmentAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "module/:moduleUuid/section/:sectionId",
    props: true,
  },
  {
    name: "AssignmentAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "module/:moduleUuid/section/:sectionId/end",
    props: true,
  },
  {
    name: "AssignmentAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId",
    props: (route) => ({
      pageId: route.params.pageId,
      openAnnotation: route.query.openAnnotation,
    }),
  },
  {
    name: "AssignmentAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "AssignmentAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "module/:moduleUuid/section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    name: "AssignmentAttemptPasscode",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonPasscode")),
    path: "passcode",
    props: true,
  },
  {
    path: "not-found",
    name: "AssignmentAttemptNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
